import React, { Component } from "react";

import { Modal, ModalOpen, ModalClose } from '../Modal';
import { Button } from "reactstrap";
import { AUAContainer } from '../AUA';
import { T } from '../traks';
import API from '../API';
import { Input } from "reactstrap";

function AdminActionsModalInit(data) {
    ModalOpen("AdminActionsModal", data);
}

const BanUser = (props) => {
    const [active, setActive] = React.useState(false);
    const [reason, setReason] = React.useState("");
  
    const doCancel = () => {
      setActive(false);
      setReason("");
    };
  
    if (!active) {
      return (
        <Button
          onClick={() => setActive(true)}
          className="ad_btn_danger mt-2"
        >
          <b>
            <T>Remove participant</T>
          </b>
        </Button>
      );
    } else {
      const doBan = () => {
        if (
          window.confirm(
            "Are you sure you want to remove this participant?"
          )
        ) {
          API.post(
            "/a/game_ban_user",
            { game_id: props.game_id, user_id: props.user_id, reason },
            (response) => {
              if (props.onUserBanned) {
                props.onUserBanned(props.user_id);
              }

              ModalClose();
            }
          );
        }
      };
      return (
        <div className="mt-2">
          <input
            type="text"
            placeholder="Reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          <Button onClick={doBan} className="ad_btn_danger">
            <b>
              <T>Remove participant</T>
            </b>
          </Button>
          <Button onClick={doCancel}>
            <T>Cancel</T>
          </Button>
        </div>
      );
    }
  };

  class AdminActionsInnerContent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        amount: '',
        loading: false,
        submitted: false,
        amountError: '',
        confirming: false,
      };
    }
  
    validateAmount = (value) => {
      const { IsGod } = this.props.aua.me;
      const numValue = parseFloat(value);
      const maxAmount = IsGod ? 100000000 : 100000;
      const minAmount = -maxAmount;
    
      if (isNaN(numValue)) {
        return "amount_invalid";
      }
      if (numValue > maxAmount || numValue < minAmount) {
        return "amount_out_of_range";
      }
      return "";
    };
  
    validateAmount = (value) => {
      const { IsGod } = this.props.aua.me;
      const numValue = parseFloat(value);
      const maxAmount = IsGod ? 100000000 : 100000;
      const minAmount = -maxAmount;
    
      if (isNaN(numValue)) {
        return "amount_invalid";
      }
      if (numValue > maxAmount || numValue < minAmount) {
        return `amount_out_of_range`;  
      }
      return "";
    };

    // Make sure we cannot enter , . or e
    handleKeyDown = (e) => {
      if (e.key === '.' || e.key === ',' || e.key === 'e') {
        e.preventDefault();
      }
    }
  
    handleApplyClick = () => {
      const { amount } = this.state;
      const { IsGod } = this.props.aua.me;
      const numValue = parseFloat(amount);
    
      if (isNaN(numValue)) {
        this.setState({ amountError: "amount_invalid" });
        return;
      }
    
      if (!IsGod) {
        if (numValue < -100000 || numValue > 100000) {
          this.setState({ amountError: "amount_out_of_range" });
          return;
        }
      } else {
        if (numValue < -100000000 || numValue > 100000000) {
          this.setState({ amountError: "amount_out_of_range" });
          return;
        }
      }
    
      this.setState({ confirming: true });
    };
  
    handleConfirm = () => {
      const { portfolioId, currency, gameId, currentPortfolioValue, onMoneyUpdate } = this.props;
      const { amount } = this.state;
  
      this.setState({ loading: true });
  
      const payload = {
        portfolioId: portfolioId,
        exchangeTicker: `BANK:${currency}`,
        amount: amount,
      };
  
      API.post(
        '/a/give_stock',
        { portfolioId: payload.portfolioId, exchangeTicker: payload.exchangeTicker, delta: amount, gameId: gameId },
        (response) => {
          this.setState({ loading: false, submitted: true, confirming: false });
          if (onMoneyUpdate) {
            const updatedValue = parseInt(amount, 10) + parseInt(currentPortfolioValue, 10);
            onMoneyUpdate({
              Id: portfolioId,
              Value: updatedValue,
            });
          }
        }
      );
    };
  
    handleCancelConfirmation = () => {
      this.setState({ confirming: false });
    };

    handleAmountChange = (event) => {
      let value = event.target.value;
      const { IsGod } = this.props.aua.me;
      const numValue = parseFloat(value);
    
      if (!IsGod) {
        if (numValue > 100000) {
          value = "100000";
        } else if (numValue < -100000) {
          value = "-100000";
        }
      } else {
        if (numValue > 100000000) {
          value = "100000000";
        } else if (numValue < -100000000) {
          value = "-100000000";
        }
      }
    
      this.setState({ amount: value, amountError: "", confirming: false });
    };
    
  
    render() {
      const { currentPortfolioValue, currency, userName, loggedInUserId, userId } = this.props;
      const currentVal = parseInt(currentPortfolioValue, 10);
      const amountVal = parseInt(this.state.amount, 10);
      const newValue = currentVal + amountVal;
  
      const isUsersOwnPortfolio = loggedInUserId === userId;
  
      let amountErrorElement = null;
      switch (this.state.amountError) {
        case "":
          break;
        case "amount_invalid":
          amountErrorElement = <span><T>Please enter a valid number.</T></span>;
          break;
        case "amount_out_of_range":
          const { IsGod } = this.props.aua.me;
          const maxAmount = IsGod ? 100000000 : 100000;
          amountErrorElement = <span><T>Amount must be between {-maxAmount} and {maxAmount}.</T></span>;
          break;
        default:
          amountErrorElement = <span><T>An unknown error occurred</T></span>;
      }

      if (this.state.confirming) {
        return (
          <div className="ad_trade_bg p-4">
            <div className="ad_150pct">
              <b><T>Confirm Capital Change</T></b>
            </div>
            <p>
              <T>You are now about to disburse or deduct capital (money) from a participant. Are you sure you want to continue?</T>
            </p>
            <div className="mt-3 d-flex justify-content-between">
              <Button onClick={this.handleConfirm} className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-outline-light">
                <T>Yes</T>
              </Button>
              <Button onClick={this.handleCancelConfirmation} className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-outline-light">
                <T>Cancel</T>
              </Button>
            </div>
          </div>
        );
      }
  
      return (
        <div className="ad_trade_bg p-4">
          {!this.state.submitted ? (
            <React.Fragment>
              <div className="ad_150pct">
                <b><T>Participant</T></b>
              </div>
              <div className="mt-2">
                <b><T>Name: </T></b><span>{userName}</span>
              </div>
              <div className="mt-2">
                <b><T>Current portfolio value: </T></b><span>{currentVal} {currency}</span>
              </div>
              {!isUsersOwnPortfolio && (
                <BanUser game_id={this.props.gameId} user_id={this.props.userId} onUserBanned={this.props.onUserBanned} />
              )}
              <div className="mt-4 ad_125pct">
                <span><T>Adjust portfolio value</T></span>
              </div>
              <div className="pb-2 py-2">
                <span><T>Game admins can adjust the value of the portfolio by any number between 100.000 and -100.000</T></span>
              </div>
              <Input
                type="number"
                placeholder="Amount"
                value={this.state.amount}
                onChange={this.handleAmountChange}
                onKeyDown={this.handleKeyDown}
                min={this.props.aua.me.IsGod ? -100000000 : -100000}
                max={this.props.aua.me.IsGod ? 100000000 : 100000}
              />
              {amountErrorElement && (
                <div className="pb-2 errors">
                  {amountErrorElement}
                </div>
              )}
              <div className="pb-2 py-2">
                <span><T>Current portfolio value: </T>{currentVal} {currency}</span>
              </div>
              {!isNaN(newValue) ? (
                <p >
                  <T>Portfolio value after change: </T> {newValue} {currency}
                </p>
              ) : (
                <p >
                  <T>Portfolio value after change: </T> {currentVal} {currency}
                </p>
              )}
              <div className="mt-3 d-flex justify-content-between">
                {this.state.loading ? (
                  <button
                    className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-outline-light"
                    disabled
                  >
                    <T>Loading...</T>
                  </button>
                ) : (
                  <button
                    onClick={this.handleApplyClick}
                    className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-outline-light"
                  >
                    <T>Adjust</T>
                  </button>
                )}
                <button
                  onClick={ModalClose}
                  className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-outline-light"
                >
                  <T>Cancel</T>
                </button>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="mt-3">
                <p>
                  <T>You have successfully changed </T>
                  {userName}s <T> portfolio value by </T> {this.state.amount} {currency}
                </p>
              </div>
              <div className="mt-3 d-flex justify-content-between">
                <button
                  onClick={ModalClose}
                  className="xyzzy_button ad_copy_link_btn align-top px-5 btn btn-outline-light"
                >
                  <T>Close</T>
                </button>
              </div>
            </React.Fragment>
          )}
        </div>
      );
    }
  }

const AdminActionsInner = (props) => <AUAContainer><AdminActionsInnerContent {...props}/></AUAContainer>;

class AdminActionsModal extends Modal {
    allow_close_via_ui() {
        return true;
    }

    mrender() {
        return <AdminActionsInner {...this.props}/>;
    }

    get_name() {
        return "AdminActionsModal";
    }

    get_fullscreen_bg_class() {
        return "ad_signuplogin_dark";
    }

    get_fullscreen() {
        return true;
    }
}

export {
    AdminActionsModalInit,
    AdminActionsModal
}


// WEBPACK FOOTER //
// ./src/c/AdminActionsModal.js